export const portfolio = () => {

    const portfolioItems = document.querySelectorAll('.portfolio--item');
    const portfolioLinks = document.querySelectorAll('.portfolio--item--link');
    const portfolioDropdowns = document.querySelectorAll('.portfolio--dropdown');
    const portfolioGrid = document.querySelector('.portfolio--grid');

    if (!portfolioLinks.length || !portfolioGrid) return;

    const closeAllModals = () => {
        document.querySelectorAll('.portfolio--modal.is-viewing').forEach(modal => {
            modal.classList.remove('is-viewing');
        });
    };

    portfolioLinks.forEach(link => {
        link.addEventListener('click', (e) => {
            e.preventDefault();

            const targetId = link.getAttribute('href')?.replace('#', '');
            const targetModal = document.getElementById(targetId);
            const clickedItem = link.closest('.portfolio--item');

            if (!targetModal || !clickedItem) return;

            // Close others before opening this one
            closeAllModals();

            const items = Array.from(portfolioGrid.querySelectorAll('.portfolio--item'));
            const clickedTop = clickedItem.getBoundingClientRect().top;
            let lastInRow = clickedItem;

            for (const item of items) {
                const top = item.getBoundingClientRect().top;
                if (Math.abs(top - clickedTop) < 5) {
                    lastInRow = item;
                } else if (top > clickedTop) {
                    break;
                }
            }

            if (lastInRow.nextElementSibling !== targetModal) {
                targetModal.remove();
                lastInRow.insertAdjacentElement('afterend', targetModal);
            }

            requestAnimationFrame(() => {
                targetModal.classList.add('is-viewing');
            });
        });
    });

    document.addEventListener('click', (e) => {
        const closeBtn = e.target.closest('.portfolio--modal__close');
        if (closeBtn) {
            e.preventDefault();
            const modal = closeBtn.closest('.portfolio--modal');
            if (modal) modal.classList.remove('is-viewing');
        }
    });

    portfolioDropdowns.forEach(dropdown => {
        const filterGroup = dropdown.closest('.filter-group');
        const labelButton = filterGroup?.querySelector('.filter-label');
        const defaultLabel = labelButton?.dataset?.default;

        const updateLabel = () => {
            const selectedValue = dropdown.value;
            const selectedText = dropdown.options[dropdown.selectedIndex]?.text;

            if (labelButton) {
                if (!selectedValue || selectedValue === '') {
                    labelButton.textContent = defaultLabel;
                } else {
                    labelButton.textContent = selectedText;
                }
            }
        };

        // Initial label
        updateLabel();

        const choicesInstance = dropdown.choices;

        const onChange = () => {
            updateLabel();
            updatePortfolioItems();
        };

        if (choicesInstance) {
            dropdown.addEventListener('change', onChange);
        } else {
            dropdown.addEventListener('change', onChange);
        }
    });

    function updatePortfolioItems() {
        console.log('🔄 updatePortfolioItems called');

        closeAllModals();

        const selectedValues = [];
        portfolioDropdowns.forEach(dropdown => {
            if (dropdown.value && dropdown.value.trim() !== '') {
                selectedValues.push(dropdown.value);
            }
        });

        portfolioItems.forEach((item) => {
            const itemClasses = Array.from(item.classList);
            let shouldShow = true;

            if (selectedValues.length > 0) {
                for (const selectedValue of selectedValues) {
                    if (!itemClasses.includes(selectedValue)) {
                        shouldShow = false;
                        break;
                    }
                }
            }

            item.classList.toggle('is-hiding', !shouldShow);
        });

        const visibleItems = document.querySelectorAll('.portfolio--item:not(.is-hiding)');
        const hiddenItems = document.querySelectorAll('.portfolio--item.is-hiding');

        console.log('\n📈 Filter Results Summary:', {
            totalItems: portfolioItems.length,
            visibleItems: visibleItems.length,
            hiddenItems: hiddenItems.length,
            activeFilters: selectedValues
        });
    }

    updatePortfolioItems();
};
